import React from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { add } from '../../assets/svg/footers'
import { useState, useEffect } from 'react'
import Modal from './Modal'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getGroups, setPage } from '../../actions/groups'
import Loader from '../../components/Loader'
import Table from '../../components/Table'
import { deleteGroup, getLanguages, getSchoolYears, getShifts, getSpecializations, getStudyForms, getStudyModes, getStudyProfiles, getTeachersList } from '../../actions/common'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { Pagination } from '../../components/Pagination'


export default function Classing() {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { groupsEnd, loading, pageCount, count, pageNumber } = useSelector(state => state.groups)

  const [classId, setClassId] = useState(null);
  const [confirmation, setConfirmation] = useState(false);
  const [sort, setSort] = useState(1)
  const [mode, setMode] = useState('main')


  useEffect(() => {
    dispatch(getTeachersList())
    dispatch(getSchoolYears())
    dispatch(getSpecializations())
    dispatch(getLanguages())
    dispatch(getStudyProfiles())
    dispatch(getStudyModes())
    dispatch(getStudyForms())
    dispatch(getShifts())
  }, [])

  useEffect(() => {
    dispatch(getGroups(sort))
  }, [sort, pageNumber])
  const handleSort = () => {
    // handleSortFio(arr, sortArr)
    setSort(sort == 1 ? 2 : 1)
  }

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteGroup(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const openModal = (classId) => () => setClassId(classId)

  const closeModal = () => {
    dispatch({ type: 'SET_GROUP_INFO', payload: null })
    dispatch({ type: 'SET_GROUP_TEAM', payload: null })
    dispatch({ type: 'SET_GROUP_HISTORY', payload: null })
    dispatch({ type: 'SET_GROUP_CURATORS', payload: null })
    setClassId(null)
    setMode('main')
  }

  const goHome = () => navigate('/')

  const pageClick = ({ selected }) => dispatch(setPage(selected))


  const sortGroups = () => { }
  const renderRow = (data) => {
    const { calc_classroom_teacher, calc_graduation_year, calc_listeners, calc_study_period, calc_training_profile, gid, name, year } = data
    return (
      <tr>
        <td onClick={openModal(gid)}>{name}</td>
        <td onClick={openModal(gid)}>{year}</td>
        <td onClick={openModal(gid)}>{calc_listeners}</td>
        <td onClick={openModal(gid)}>{calc_graduation_year}</td>
        <td onClick={openModal(gid)}>{calc_training_profile}</td>
        <td onClick={openModal(gid)}>{calc_study_period}</td>
        <td onClick={openModal(gid)}>{calc_classroom_teacher}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: gid, name: name })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ paddingBottom: '5rem' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title="Удалить данную запись?"
          confirmation={confirmation?.name}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}


      <Modal
        classId={classId}
        closeModal={closeModal}
        classing
        infoCreateChange={groupsEnd?.find(group => group.gid === classId)}
        mode={mode}
        setMode={setMode}
      />

      <h1>Распределение по классам</h1>

      {loading
        ? <Loader />
        : groupsEnd?.length &&
        <Pagination
          pageCount={pageCount}
          pageNumber={pageNumber}
          onPageChange={pageClick}
          loading={loading}
        >
          <div className={styles.tableScroll}>
            <Table maxHeight='67vh' style={{ backgroundColor: 'white', maxHeight: '67vh' }}>
              <thead>
                <tr>
                  <th onClick={handleSort}>Название</th>
                  <th>Год</th>
                  <th>Количество слушателей</th>
                  <th>Год выпуска</th>
                  <th>Профиль обучения</th>
                  <th>Тип уч. периода</th>
                  <th>Классный руководитель</th>
                  <th>Удалить</th>
                </tr>
              </thead>
              <tbody>
                {groupsEnd?.map(renderRow)}
              </tbody>
            </Table>
          </div>
        </Pagination>
      }
      <footer className={styles.footer}>
        <div>
          <Button className={styles.footerButton} onClick={openModal('add')} mode='bordered'>{add()}Добавить</Button>
        </div>
        <Button mode='white' onClick={goHome}>Закрыть</Button>
      </footer>
    </div>
  )
}
